const prodConfig = {
    env: "prod",
    amplitudeAPIKey: process.env.PROD_SERVER_AMPLITUDE_API_KEY ?? "",
};
const stagingConfig = {
    ...prodConfig,
    env: "staging",
    amplitudeAPIKey: process.env.PROD_SERVER_AMPLITUDE_API_KEY ?? "",
};
const devConfig = {
    env: "dev",
    amplitudeAPIKey: process.env.DEV_SERVER_AMPLITUDE_API_KEY ?? "",
};
const localConfig = {
    ...devConfig,
    env: "local",
};
const testConfig = {
    ...localConfig,
    env: "test",
};
const clientConfig = {
    prod: prodConfig,
    staging: stagingConfig,
    dev: devConfig,
    local: localConfig,
    test: testConfig,
};
function isConfigKey(key) {
    return key != null && key in clientConfig;
}
const env = process.env.ENVIRONMENT;
if (!isConfigKey(env))
    throw new Error(`invalid ENVIRONMENT value: ${env}`);
export const config = clientConfig[env];
//# sourceMappingURL=config.js.map